import axios from "axios";
import md5 from "md5";
import { getHeader } from "../../utils/utils";
import { API_BASE_URL } from "../../utils/config";

const API_URL = API_BASE_URL + "/organizations/";

const OAuth_API_URL = API_BASE_URL + "/organizations/oauth/";

class OrgService {
  getOrganizationList(token) {
    return axios.get(API_URL, {
      headers: getHeader(token),
    });
  }

  createNewOrganization(token, name) {
    return axios({
      method: "post",
      url: API_URL,
      headers: getHeader(token),
      data: {
        name: name,
      },
    });
  }

  createNewUserForOrganization(token, id, email, password, name) {
    let md5Password = md5(password);
    return axios({
      method: "post",
      url: API_URL + id + "/admin",
      headers: getHeader(token),
      data: {
        email: email,
        password: md5Password,
        name: name,
      },
    });
  }

  createNewUserOAuthForOrganization(
    token,
    id,
    newOAuthUserEmail,
    newUserName,
    provider
  ) {
    return axios({
      method: "post",
      url: OAuth_API_URL + id + "/admin",
      headers: getHeader(token),
      data: {
        email: newOAuthUserEmail,
        auth: provider,
        name: newUserName,
      },
    });
  }

  editOrganization(token, name, id) {
    return axios({
      method: "patch",
      url: API_URL + id,
      headers: getHeader(token),
      data: {
        name: name,
      },
    });
  }
}

export default new OrgService();
